import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { media } from '../../../utilities/media';
import { gridWidth } from '../../../utilities/grid';
import { Icon } from '../../atoms/Icon';
import { Link } from '../../atoms/Link/Link';
const StyledFooter = styled.footer `
  font-family: ${({ theme }) => theme.typography.font.family.text};
  font-size: ${props => props.theme.typography.font.sizes.small}px;
  color: ${props => props.theme.palette.neutral.dark};
  line-height: 1.31;
  width: 100%;
  height: 100%;
  padding: 40px 16px 24px 16px;
  ul:not(:first-child) {
    margin-top: 24px;
  }
  ${media.tablet `
    padding-top: 80px;
    margin 0 auto;
    max-width: ${gridWidth['tablet'](12)}px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    ul:not(:first-child) {
      margin-top: auto;
    }
  `};
`;
const List = styled.ul `
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: flex-start;
  ${media.tablet `
  max-width: 50%;
  `};
`;
const Item = styled.li `
  width: 100%;
`;
const Wrapper = styled.span `
  display: inline;
  ${media.tablet `
    display: block;
  `};
`;
const Contact = styled.li `
  width: 100%;
  display: flex;
  align-items: center;
  svg {
    margin-right: 8px;
  }
  ${media.tablet `
    width: auto;
    margin-right: 32px;
  `};
`;
const Contacts = styled.ul `
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  ${media.tablet `
    flex-direction: row;
  `};
`;
const FooterComponent = ({ leftText, phone, email, rightText, copyRight, theme, }) => (React.createElement(StyledFooter, null,
    React.createElement(List, null,
        React.createElement(Item, null, leftText),
        React.createElement(Contacts, null,
            React.createElement(Contact, null,
                React.createElement(Icon, { sprite: "icon-phone", width: 13, height: 13 }),
                React.createElement(Link, { role: "darker", size: "small", href: `tel:${phone}` }, phone)),
            React.createElement(Contact, null,
                React.createElement(Icon, { sprite: "icon-email", width: 13, height: 13, color: theme.palette.neutral.dark }),
                React.createElement(Link, { role: "darker", size: "small", href: `mailto:${email}` }, email)))),
    React.createElement(List, null,
        React.createElement(Item, null,
            "\u00A9",
            new Date().getFullYear(),
            " ",
            copyRight,
            " ",
            React.createElement(Wrapper, null, rightText)))));
export const Footer = withTheme(FooterComponent);
//# sourceMappingURL=index.js.map